import { useState, useMemo } from "react";
import type { RowBase } from "../data-table.js";

type PaginationConfig = {
  enabled: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
  showPageSizeSelector?: boolean;
  showResultsInfo?: boolean;
};

export const useDataTablePagination = <TRow extends RowBase>(
  data: TRow[],
  config: PaginationConfig
) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(config.pageSize || 10);

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = currentPage * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);

  const paginatedData = useMemo(() => {
    if (!config.enabled) return data;
    return data.slice(startIndex, endIndex);
  }, [data, config.enabled, startIndex, endIndex]);

  return {
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    totalPages,
    paginatedData,
  };
};
